document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      var expanded = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!expanded));
    });
  }

  // Quantity steppers
  document.querySelectorAll('[data-quantity-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    wrapper.querySelectorAll('[data-quantity-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-quantity-step'), 10);
        var current = parseInt(input.value || '1', 10);
        var next = Math.max(1, current + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product gallery thumbnail swap
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full-src');
      var main = document.querySelector('[data-gallery-main-img]');
      if (main && full) {
        main.src = full;
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      }
    });
  });

  // Cart drawer / header count update after add-to-cart (AJAX API)
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-adding-text') || 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var countEls = document.querySelectorAll('[data-cart-count]');
          countEls.forEach(function (el) { el.textContent = cart.item_count; });
          if (submitBtn) {
            submitBtn.textContent = submitBtn.getAttribute('data-added-text') || 'Added ✓';
            setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.getAttribute('data-original-text') || 'Add to cart';
            }, 1600);
          }
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.getAttribute('data-original-text') || 'Add to cart'; }
          form.submit(); // fallback to normal submit
        });
    });
  });

});
